import React, { useEffect, useState } from "react";
import { Facebook, Instagram, Linkedin, Twitter } from "lucide-react";
import { Link } from "react-router-dom";
import BASE_URL from "./apibaseurl/ApiBaseUrl";  // Apne API base URL ka sahi path dijiye

interface SocialMedia {
  facebook?: string;
  instagram?: string;
  linkedin?: string;
  twitter?: string;
}

interface Settings {
  site_name: string;
  site_logo: string;
  footer_description: string;
  footer_copyright_text: string;
  social_media?: SocialMedia;
}

interface ApiResponse {
  status: number;
  data: {
    settings: Settings;
  };
}

export default function Footer() {
  const [settings, setSettings] = useState<Settings | null>(null);
  const [social_media, setsocial_media] = useState<Settings | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string>("");
const hasFetched = React.useRef(false);
const [socialMedia, setSocialMedia] = useState<SocialMedia | null>(null);
console.log("socialMedia",socialMedia)

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
useEffect(() => {
  if (hasFetched.current) return;
  hasFetched.current = true;

  const fetchData = async () => {
    setLoading(true);
    setError("");
    try {
      const res = await fetch(`${BASE_URL}/splashScreen`);
      if (!res.ok) throw new Error("Network response was not ok");
      const json: ApiResponse = await res.json();

      if (json.status === 1 && json.data?.settings) {
        setSettings(json.data.settings);
        setSocialMedia(json.data.social_media || null); // optional
      } else {
        setError("Failed to load footer data");
      }
    } catch (err) {
      setError("Error fetching footer data");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };
  fetchData();
}, []);


  if (error) {
    return (
      <footer className="bg-[#234042] py-10 px-4 text-center text-red-400">
        {error}
      </footer>
    );
  }

  if (!settings) {
    return null;
  }

  return (
    <footer
      className="static bottom-0 left-0 w-full z-50 bg-[#234042] py-10 px-4"
      style={{
        backgroundImage: `url('/images/Clip.png')`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
      }}
    >
      <div className="max-w-7xl mx-auto space-y-6">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-start md:space-x-6 space-y-4 md:space-y-0">
          <div className="text-left md:text-left w-full md:w-auto">
            <div className="flex flex-col md:flex-row items-start justify-between md:items-start space-y-2 md:space-y-0 md:space-x-10">
              {/* site name */}
            
              <h2 className="text-white text-[35px] whitespace-nowrap Bebas-neue">
                {settings.site_name}
              </h2>

              <div className="hidden md:block h-12 w-px bg-gray-500" />

              <p className="text-sm text-white helvetica-neue ">
                {settings.footer_description}
              </p>
            </div>
          </div>

          {/* Social Icons with dynamic URLs */}
         <div className="flex space-x-3">
          {socialMedia?.facebook && (
            <a
              href={socialMedia.facebook}
              className="group relative w-12 h-12 rounded-full overflow-hidden border-2 border-white/30 bg-white/20 flex items-center justify-center transition-all duration-500"
              aria-label="Facebook"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span className="absolute top-full left-0 w-full h-full bg-[#234042] transition-all duration-500 z-0 group-hover:top-0"></span>
              <Facebook
                size={18}
                className="text-[#262626] z-10 relative transition-all duration-500 group-hover:text-white group-hover:rotate-[360deg]"
              />
            </a>
          )}

  {socialMedia?.instagram && (
    <a
      href={socialMedia.instagram}
      className="group relative w-12 h-12 rounded-full overflow-hidden border-2 border-white/30 bg-white/20 flex items-center justify-center transition-all duration-500"
      aria-label="Instagram"
      target="_blank"
      rel="noopener noreferrer"
    >
      <span className="absolute top-full left-0 w-full h-full bg-[#234042] transition-all duration-500 z-0 group-hover:top-0"></span>
      <Instagram
        size={18}
        className="text-[#262626] z-10 relative transition-all duration-500 group-hover:text-white group-hover:rotate-[360deg]"
      />
    </a>
  )}

  {socialMedia?.linkedin && (
    <a
      href={socialMedia.linkedin}
      className="group relative w-12 h-12 rounded-full overflow-hidden border-2 border-white/30 bg-white/20 flex items-center justify-center transition-all duration-500"
      aria-label="LinkedIn"
      target="_blank"
      rel="noopener noreferrer"
    >
      <span className="absolute top-full left-0 w-full h-full bg-[#234042] transition-all duration-500 z-0 group-hover:top-0"></span>
      <Linkedin
        size={18}
        className="text-[#262626] z-10 relative transition-all duration-500 group-hover:text-white group-hover:rotate-[360deg]"
      />
    </a>
  )}

  {socialMedia?.twitter && (
    <a
      href={socialMedia.twitter}
      className="group relative w-12 h-12 rounded-full overflow-hidden border-2 border-white/30 bg-white/20 flex items-center justify-center transition-all duration-500"
      aria-label="Twitter"
      target="_blank"
      rel="noopener noreferrer"
    >
      <span className="absolute top-full left-0 w-full h-full bg-[#234042] transition-all duration-500 z-0 group-hover:top-0"></span>
      <Twitter
        size={18}
        className="text-[#262626] z-10 relative transition-all duration-500 group-hover:text-white group-hover:rotate-[360deg]"
      />
    </a>
  )}
</div>


        </div>

        <hr className="border-gray-500" />
        <div className="flex text-[#888888] helvetica-neue flex-col md:flex-row justify-between items-center text-sm space-y-4 md:space-y-0">
          <p>{settings.footer_copyright_text}</p>
          <div className="flex space-x-4">
            <Link
              to="/terms-of-use"
              className="hover:text-white"
              onClick={scrollToTop}
            >
              Terms of Use
            </Link>

            <span>|</span>
            <Link
              to="/privacy-policy"
              className="hover:text-white"
              onClick={scrollToTop}
            >
              Privacy Policy
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
